module.exports = __webpack_public_path__ + "media/customizations/caldwellcommunities/logo-b7b69384299c255b24da52171cc6fa24.png";